import React from 'react';
import BrandSearchProvider, {
  useBrandSearchSelector,
} from '../BrandSearchProvider';
import BrandSlider from '../BrandSlider';
import { selectBrands, selectIsBrandSearching } from '~redux/search/brand';

const Slider: React.FC<{ listId: string }> = React.memo(({ listId }) => {
  const brands = useBrandSearchSelector(selectBrands, listId);
  const isSearching = useBrandSearchSelector(selectIsBrandSearching, listId);
  if (isSearching) {
    return <BrandSlider isLoading />;
  }
  return <BrandSlider brands={brands} title="商品が更新されたブランド" />;
});

const UpdatedBrands: React.FC<{ category?: string }> = ({ category }) => {
  const listId = `brands > updated${category ? ` > ${category}` : ''}`;
  return (
    <BrandSearchProvider
      listId={listId}
      itemsPerPage={50}
      category={category}
      filterValues={{
        items: ['items > 0'],
        lastPublishedAtTimestamp: [
          `lastPublishedAtTimestamp >= ${
            new Date().getTime() - 30 * 24 * 60 * 60 * 1000
          }`,
        ],
      }}
    >
      <Slider listId={listId} />
    </BrandSearchProvider>
  );
};

export default UpdatedBrands;
